import type {
  AdaptivePlayerProfile,
  CompletedHandRecord,
  Ruleset,
  SavedMatch,
  UserPreferences,
} from './types.js';

/** Current IndexedDB schema version — bump when migrations are added. */
export const STORAGE_SCHEMA_VERSION = 2;

export const PREFERENCES_KEY = 'user';
export const ADAPTIVE_PROFILE_KEY = 'default';
export const META_SCHEMA_KEY = 'schemaVersion';
export const META_APP_VERSION_KEY = 'appVersion';

export const DEFAULT_USER_PREFERENCES: UserPreferences = {
  animationSpeed: 'normal',
  soundEnabled: true,
  confirmBeforePlay: false,
  assistance: 'off',
  largeDominoMode: false,
  colorfulPips: false,
  highContrastMode: false,
  reducedMotion: false,
};

export const DEFAULT_ADAPTIVE_PROFILE: AdaptivePlayerProfile = {
  profileId: ADAPTIVE_PROFILE_KEY,
  completedHands: 0,
  confidence: 0,
  updatedAt: new Date(0).toISOString(),
};

/** JSON export bundle for local backup and restore. */
export interface PersistenceBackup {
  schemaVersion: number;
  exportedAt: string;
  appVersion: string;
  matches: SavedMatch[];
  completedHands: CompletedHandRecord[];
  rulesets: Ruleset[];
  preferences: UserPreferences;
  adaptiveProfile: AdaptivePlayerProfile;
}

export type QuarantineRecordType =
  | 'match'
  | 'completedHand'
  | 'ruleset'
  | 'preferences'
  | 'adaptiveProfile';

export interface QuarantinedRecord {
  id: string;
  recordType: QuarantineRecordType;
  reason: string;
  detectedAt: string;
  payload: unknown;
}
